import React, { useState } from "react";

export default function InfiniteScrollingBanner({
  text = "",
  speed = 20,
  className = "",
  heightClass = "h-12",
}) {
  const [paused, setPaused] = useState(false);

  return (
    <>
      <style>{`
        @keyframes marqueeSingle {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .marquee-single {
          white-space: nowrap;
          display: inline-block;
          animation: marqueeSingle var(--marquee-duration, 20s) linear infinite;
        }
        .paused {
          animation-play-state: paused;
        }
      `}</style>

      <div
        className={`w-full overflow-hidden ${heightClass} ${className} bg-gray-900 text-gray-100 flex items-center`}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <span
          className={`marquee-single ${paused ? "paused" : ""}`}
          style={{ ["--marquee-duration"]: `${speed}s` }}
        >
          {text}
        </span>
      </div>
    </>
  );
}
